export default "__VITE_PUBLIC_ASSET__7f42181b__"